import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import ReadMore from 'components/ReadMore';

import './TeacherInformation.css';

class TeacherInformation extends Component {
  renderDescription(description) {
    const { hasReadMore } = this.props;

    const content = (
      <div className="card-text hidden-sm-down">
        <p>{description}</p>
      </div>
    );

    return hasReadMore ? <ReadMore className="hidden-sm-down">{content}</ReadMore> : content;
  }

  renderSecondaryDetails(teacher) {
    const { nationality } = teacher;
    const countryOfResidence = teacher.country_of_residence;

    if (nationality && countryOfResidence) {
      return (
        <span>
          <span className="hidden-xs-down"> &bull; </span>
          <br className="hidden-sm-up" />
          {nationality} living in {countryOfResidence}
        </span>
      );
    }

    return null;
  }

  renderNewOrFeaturedBadge(teacher) {
    if (teacher.achievement === 'featured') {
      return (
        <div className="achievement">
          <span className="teacher-status font-weight-bold text-primary text-uppercase">
            Featured
          </span>
        </div>
      );
    }

    if (teacher.achievement === 'new' || !this.hasRatings(teacher) || !this.hasAttendance(teacher)) {
      return (
        <div className="achievement">
          <span className="teacher-status font-weight-bold text-primary text-uppercase">New</span>
        </div>
      );
    }

    return null;
  }

  renderTeacherName(isAdmin, teacher) {
    if (this.props.linkTeacherPage === true) {
      return <Link to={`/schedule-lesson/${teacher.slug}`}>{teacher.name}</Link>;
    }
    return isAdmin && teacher.name && teacher.familyName ? `${teacher.name} ${teacher.familyName}` : teacher.name;
  }

  renderTeacherEmail(isAdmin, teacher) {
    return isAdmin && teacher.email ? teacher.email : null;
  }

  hasRatings(teacher) {
    return teacher.rating != null && teacher.rating >= 3.1;
  }

  hasAttendance(teacher) {
    return teacher.attendanceRating != null && teacher.attendanceRating > 0;
  }

  render() {
    const classes = classNames('TeacherInformation', this.props.className);
    const { teacher, user } = this.props;
    const isAdmin = user && user.role === 'admin';

    if (_.isEmpty(teacher)) {
      return <div className={classes}> Unable to load teacher </div>;
    }

    return (
      <div className={classes}>
        <div className="card-title text-center text-md-left">
          {// if hideBadge is not true, renderNewOrFeaturedBadge
            this.props.hideBadge !== true && this.renderNewOrFeaturedBadge(teacher)
          }

          <div className="teacher-title">
            <div className="teacher-passport d-flex">
              <div className="teacher-name">
                {this.renderTeacherName(isAdmin, teacher)}
              </div>

              <div className="teacher-flag">
                {teacher.country &&
                  <img
                    width={20}
                    alt={teacher.countryName}
                    title={teacher.countryName}
                    src={`/assets/country/${teacher.country}.png`}
                    ref={img => this.img = img}
                    onError={() => this.img.src = '/assets/country/flag_not_found.png'}
                  />
                }
              </div>
            </div>

            {!this.props.hideRatings && this.hasRatings(teacher) &&
              <div className="rating">
                <span className="rating-score">
                  {teacher.rating.toFixed(1)}
                </span>

                <img
                  className="rating-star"
                  width={14}
                  src={`/assets/star.png`}
                />

                <span className="rating-count">
                  {teacher.ratingCount} {teacher.ratingCount == 1 ? 'rating' : 'ratings'}
                </span>
              </div>
            }
          </div>

          <div id="mobile-space">&nbsp;</div>
  
          <div className="subtitle">
            <div className="teacher-services">
              <div className="teaching-services">
                Teaches {teacher.services.join(", ")}
              </div>

              {!_.isEmpty(teacher.languages) &&
                <Fragment>
                  <div className="teacher-services-separator">
                    &bull;
                  </div>
                  <div className="speaking-services">
                    Speaks {teacher.languages.join(", ")}
                  </div>
                </Fragment>
              }
            </div>

            {!this.props.hideRatings && this.hasAttendance(teacher) &&
              <div className="attendance">
                {teacher.attendanceRating}% attendance
              </div>
            }
          </div>
          { this.renderTeacherEmail(isAdmin, teacher) }
        </div>
        <div className="description">
        {// if hideDescription is not true, renderDescription
          this.props.hideDescription !== true && this.renderDescription(teacher.description)
        }
        </div>
      </div>
    );
  }
}

export default TeacherInformation;



// WEBPACK FOOTER //
// ./src/components/TeacherInformation/TeacherInformation.js